export interface GlobalConfiguration {
  id: number;
  inicioHorarioPermitidoImportacao: string;
  fimHorarioPermitidoImportacao: string;
  inicioHorarioRelatorioEstoque: string;
  fimHorarioRelatorioEstoque: string;
  inicioHorarioDisponibilizarLiquidacao: string;
  fimHorarioDisponibilizarLiquidacao: string;
  inicioHorarioConciliacaoDeposito: string;
  fimHorarioConciliacaoDeposito: string;
  expiracaoCertificadora: string;
  expiracaoConsultoria: string;
  expiracaoCustodiante: string;
  expiracaoAdministrador: string;
  expiracaoGestor: string;
  expiracaoGestorTED: string;
}

export interface GlobalConfigurationApi {
  id?: number;
  inicioHorarioPermitidoImportacao: string;
  fimHorarioPermitidoImportacao: string;
  inicioHorarioRelatorioEstoque: string;
  fimHorarioRelatorioEstoque: string;
  inicioHorarioDisponibilizarLiquidacao: string;
  fimHorarioDisponibilizarLiquidacao: string;
  inicioHorarioConciliacaoDeposito: string;
  fimHorarioConciliacaoDeposito: string;
  expiracaoCertificadora: string;
  expiracaoConsultoria: string;
  expiracaoCustodiante: string;
  expiracaoAdministrador: string;
  expiracaoGestor: string;
  expiracaoGestorTED: string;
}
